import React, { FunctionComponent, useContext } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { Outlet } from 'react-router-dom';
import { Loader } from 'components/Loader';
import { ChannelHeader } from 'features/channel/components/ChannelHeader';
import { ChannelFooter } from 'features/channel/components/ChannelFooter';
import { ChannelBanned } from 'features/channel/components/ChannelBanned/ChannelBanned';
import { SEOHeaderTags } from 'components/SEO/SEOHeaderTags';
import { ChannelSmartBanner } from 'components/SmartBanner/Channel';
import { PageAnimationOpacity } from 'components/LayoutAnimations/PageAnimationOpacity';
import { cloudflareUrl } from 'utilities/cloudflareImageResizer';
import { useSEOTitleDescription } from 'hooks/useSEOTitleDescription';
import { UserAgentContext } from 'features/user-agent/userAgent';

export const Channel: FunctionComponent = () => {
  const channel = useSelector(
    (state: RootState) => state.channel.channelDetails
  );
  const channelisLoaded = useSelector(
    (state: RootState) => state.channel.isLoaded
  );
  const channelUrl = window.location.href;

  const unavailable = useSelector(
    (state: RootState) => state.channel.channelUnavailable
  );

  const { pageTitle, pageDescription } = useSEOTitleDescription();
  const { isNativeAppWebview } = useContext(UserAgentContext);

  if (unavailable) {
    return <ChannelBanned />;
  }

  if (!channelisLoaded || channel == null) {
    return <Loader fillComponent={true} hideOnNative={isNativeAppWebview} />;
  }

  const imgUrl = cloudflareUrl(channel.artworkKey, {
    width: 800,
    quality: 80,
    baseUrl: channel.channelId
      ? process.env.REACT_APP_STORAGE_CDN_URL
      : undefined
  });

  return (
    <>
      <SEOHeaderTags
        title={pageTitle}
        description={pageDescription}
        image={imgUrl}
        url={channelUrl}
      />
      <ChannelSmartBanner />
      <PageAnimationOpacity>
        <ChannelHeader />
        <main className="app__main" role="main">
          <Outlet />
        </main>
        <ChannelFooter />
      </PageAnimationOpacity>
    </>
  );
};
